<template>
  <div class="campo">
    <fai transform="shrink-4 rotate-160" icon="phone" style="color: #0053a2;" />
    <span v-if="valor">{{ valor }}</span>
    <CampoVacio v-else />
  </div>
</template>

<script>
export default {
  props: {
    valor: { type: [String, Number], required: false, default: null }
  }
};
</script>

<style scoped>
.campo {
  padding-bottom: 0.5rem;
}
</style>
